export default "__VITE_ASSET__a7b0a146__"